import React from 'react';
import '../../components/TopNavbarComponents/TPI.css';

const Transportation = () => {
    return (
        <div className="tpi-coming-soon font-poppins">
            <h1>Coming Soon</h1>
        </div>
    );
};

export default Transportation;
